import * as Icons from 'lucide-react';
import { LucideProps } from 'lucide-react';

interface IconProps extends LucideProps {
  name: keyof typeof Icons;
  color?: string;
  size?: number;
}

export const Icon = ({ name, color, size = 20, 'aria-hidden': ariaHidden = true, ...props }: IconProps) => {
  const LucideIcon = Icons[name] as React.ElementType;

  if (!LucideIcon) return null;

  return <LucideIcon color={color} size={size} aria-hidden={ariaHidden} focusable="false" {...props} />;
};
